module.exports = __webpack_public_path__ + "static/media/discount-image-promo.0bb69d6d.png";